import { WarnIcon } from "@shared/ui/Icon/ui/history/warn-icon";
import { ReportPaymentsProps } from "./types";
import classes from "./report-payments.module.scss";

export const ReportPayments = ({ insurancePayments }: ReportPaymentsProps) => {
    const hasPayments = Array.isArray(insurancePayments) && insurancePayments.length > 0;

    return (
        <div className={classes.payments}>
            <div className={classes.payments__note}>
                <WarnIcon className={classes["payments__note--icon"]} />
                После повреждений страховые компании компенсируют ущерб. Выплата не гарантирует, что
                машину ремонтировали
            </div>
            <div className={classes.payments__result}>
                {!hasPayments ? "Страховых выплат не было" : "Страховой случай зафиксирован"}
                <span className={classes.payments__data}>По данным Автотеки</span>
            </div>
        </div>
    );
};